// import React, { useEffect, useState } from "react";

// export default function Hero() {
//     const [isOpen, setIsOpen] = useState(false);

//     const precios = [
//         {
//             categoria: "General",
//             normal: 280,
//             preventa: 210,
//             fechas: {
//                 normal: "01 nov - 13 nov",
//                 preventa: "10 sept - 16 oct"
//             }
//         },
//         {
//             categoria: "Socios (20% desc.)",
//             normal: 224,
//             preventa: 168,
//             fechas: {
//                 normal: "01 nov - 13 nov",
//                 preventa: "10 sept - 16 oct"
//             }
//         },
//         {
//             categoria: "Estudiantes",
//             normal: 80,
//             preventa: 80,
//             fechas: {
//                 normal: "01 nov - 13 nov",
//                 preventa: "10 sept - 16 oct"
//             }
//         }
//     ];

//     return (
//         <section className="hero">
//             {/* Izquierda */}
//             <div className="hero-left">
//                 <div className="hero-content">
//                     <h1>
//                         <span className="hashtag">#ConMujeres</span><br />
//                         como tú,<br />
//                         todo es posible.
//                     </h1>
//                     {/* <p className="text">
//                         ConMujeres 2025 un encuentro especial donde la <br /> inspiración se
//                         convierte en conexión y la conexión <br />en acción.
//                     </p> */}
//                     <hr />
//                     <p className="org">
//                         <strong>Organizado por:<br />
//                             Comisión de mujeres empresarias de la CCIA.</strong>
//                     </p>
//                     <button className="btn-preventa" onClick={() => setIsOpen(true)}>PREVENTA</button>
//                 </div>
//                 {/* Popup */}
//                 <div className={`modal-overlay ${isOpen ? "show" : ""}`} onClick={() => setIsOpen(false)}>
//                     <div className="modal-content" onClick={(e) => e.stopPropagation()}>
//                         <h2 className="modal-title">🎟️ Entradas ConMujeres 2025 🎟️</h2>

//                         <div className="prices-grid">

//                             {/* General */}
//                             <div className="price-card">
//                                 <h3>General</h3>
//                                 <div className="price-values">
//                                     <p className="price-dates">PREVENTA</p>
//                                     <p className="price-dates">(10 Sept - 16 Oct)</p>
//                                     <span className="price-preventa">S/ 210</span>
//                                 </div>
//                                 <p className="price-dates">TARIFA REGULAR</p>
//                                 <p className="price-dates">(01 Nov - 13 Nov)</p>
//                                 <div className="price-values">
//                                     <span className="price-normal">S/ 280</span>
//                                 </div>
//                             </div>

//                             {/* Socios */}
//                             <div className="price-card">
//                                 <h3>Socios CCIA (-20%)</h3>
//                                 <div className="price-values">
//                                     <p className="price-dates">PREVENTA</p>
//                                     <p className="price-dates">(10 Sept - 16 Oct)</p>
//                                     <span className="price-preventa">S/ 168</span>
//                                 </div>
//                                 <p className="price-dates">TARIFA REGULAR</p>
//                                 <p className="price-dates">(01 Nov - 13 Nov)</p>
//                                 <div className="price-values">
//                                     <span className="price-normal">S/ 224</span>
//                                 </div>
//                             </div>

//                             {/* Estudiantes */}
//                             <div className="price-card">
//                                 <h3>Estudiantes</h3>
//                                 <div className="price-values">
//                                     <p className="price-dates">ÚNICO PRECIO</p>
//                                     <p className="price-dates">(Todo el periodo)</p>
//                                     <span className="price-preventa">S/ 80</span>
//                                 </div>
//                             </div>

//                         </div>

//                         <a
//                             href="https://wa.link/ho8ljj"
//                             target="_blank"
//                             rel="noopener noreferrer"
//                             className="modal-btn"
//                         >
//                             Reservar por WhatsApp
//                         </a>

//                         <button className="modal-close" onClick={() => setIsOpen(false)}>✖</button>

//                     </div>
//                 </div>

//             </div>

//             {/* Derecha */}
//             <div
//                 className="hero-right"
//                 style={{
//                     backgroundImage: `url("/images/background.png")`,
//                     backgroundSize: "cover",
//                     backgroundPosition: "center",
//                     backgroundRepeat: "no-repeat",
//                 }}
//             >
//                 <div className="logos-row">
//                     {/* <p>Organizado por:</p> */}
//                     <div className="logos">
//                         {/* <img src="/images/logoME.png" alt="Logo ME" /> */}
//                         <img src="/images/logoCCIA.png" alt="Logo CCIA" />
//                     </div>
//                 </div>

//                 <div className="speaker-container">
//                     <img
//                         src="/images/img_hero.png"
//                         alt="Ponente ConMujeres"
//                         className="speaker"
//                     />
//                 </div>
//             </div>


//         </section >
//     );
// }

export default function Hero() {
  return (
    <section className="hero-image w-full overflow-hidden">
      <img
        src="/images/img_hero.jpg"
        alt="Imagen principal"
        className="w-full h-auto object-cover"
      />
      <img
        src="/images/banner.jpg"
        alt="Imagen principal"
        className="w-full h-auto object-cover"
      />
    </section>
  );
}
